function Button() {
  return (
    <button className="inputs__btn" type="submit">
      <img
        className="inputs__btn-icon"
        src="./assets/images/icon-calculator.svg"
        alt="Calculator icon"
      />
      Calculate Repayments
    </button>
  );
}

export default Button;
